import { subsidiaryDenominations } from "../../../../../utils/addressUtils";

/**
 * Returns a list of available coins from props, formatted for the country
 * specific coin denomination (e.g. € or P).
 * @param props
 */
function getSelectableCoins(
    props: any
):
    | { label: any; value: any }[]
    | { [key: string]: any; label: any; selected?: boolean; value: any }[] {
    return props.denominationsList.denominations.map(item => {
        return {
            label: subsidiaryDenominations[
                props.denominationsList.country_id
            ]((item / 100).toString()),
            value: item
        };
    });
}

export default getSelectableCoins;
